<template>
  <div class="container-warp">
    <Top-Nav pageTitle="试题详情"
             @click-left="pageBack"></Top-Nav>
    <div class="main-content">
      <Question-item v-if="questionDetailData"
                     :questionItem="questionDetailData"
                     :questionTagOptions="questionTags"></Question-item>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { examQuestionDetails } from "@/api/examQuestionBank.js";
import QuestionItem from "@/components/QuestionItem/QuestionItem.vue";
export default {
  name: 'questionDetails',
  components: { QuestionItem },
  data() {
    return {
      questionDetailData: null
    }
  },
  computed: {
    ...mapGetters(['questionTags']),
  },
  created() {
    console.log(this.questionTags)
    this.getQuestionDetails()
  },
  methods: {
    async getQuestionDetails() {
      const questionId = this.$route.query.id
      if (!questionId) {
        this.$toast({
          message: '参数错误',
          type: 'fail',
          duration: 2000,
          forbidClick: true,
          onClose: () => {
            this.$router.back()
          }
        })
        return
      }
      const { status, response } = await examQuestionDetails(questionId)
      if (status == 200) {
        this.questionDetailData = response
      }
      console.log(this.questionDetailData)
    }
  },
}
</script>

<style lang="less" scoped>
.container-warp {
  background-color: #fff;
}
.main-content {
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
}
</style>